$(document).on('click', '.bn_author__cycles-item-slide', function () {
    let that = $(this),
        wrapper = that.parents('.bn_author__cycles-item'),
        content = wrapper.find('.bn_author__cycles-item-content-wrapper');

    content.slideDown();

    that.hide();
});